import React from "react";
import { useNavigate } from "react-router-dom";
import { useBilling } from "@/contexts/BillingContext";
import { useAuth } from "@/contexts/AuthContext";
import { Lock, Crown, Sparkles, Clock } from "lucide-react";

const ALLOWED_PATHS = ["/billing", "/login", "/auth/callback", "/impostazioni"];

export const SubscriptionGate = ({ children }) => {
    const { billing } = useBilling();
    const { user } = useAuth();
    const navigate = useNavigate();

    if (!billing || !user) return children;
    if (billing.subscription_active) return children;
    if (ALLOWED_PATHS.some((p) => window.location.pathname.startsWith(p))) return children;

    const isAdmin = user.role === "admin";
    const trialUsed = billing.trial_used;

    return (
        <div className="min-h-[80vh] flex items-center justify-center p-6">
            <div className="max-w-2xl w-full bg-surface border border-[#1f2c44] rounded-lg p-8 lg:p-12 text-center" data-testid="subscription-gate">
                <div className="w-20 h-20 rounded-full bg-brand-soft border border-brand/40 flex items-center justify-center mx-auto mb-6">
                    <Lock className="w-10 h-10 text-brand" />
                </div>

                <div className="text-xs uppercase tracking-[0.3em] text-brand mb-3">
                    {trialUsed ? "Trial scaduto" : "Abbonamento richiesto"}
                </div>
                <h1 className="font-display text-3xl lg:text-4xl font-bold text-warm mb-4">
                    {trialUsed ? "Il periodo di prova è terminato" : "Smart Table è in pausa"}
                </h1>
                <p className="text-elegant max-w-md mx-auto mb-8">
                    {isAdmin ? (
                        trialUsed
                            ? "Il tuo trial gratuito di 10 giorni è scaduto. Attiva l'abbonamento Premium €200/mese per continuare a usare Smart Table senza interruzioni."
                            : "Per continuare a usare tavoli, ordini, cucina e cassa, attiva l'abbonamento Premium €200/mese."
                    ) : (
                        "L'abbonamento del ristorante non è attivo. Contatta l'admin per riattivare il servizio."
                    )}
                </p>

                {isAdmin && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 text-left">
                        <div className="bg-deep border border-[#1f2c44] rounded-lg p-4 flex items-start gap-3">
                            <Crown className="w-5 h-5 text-brand mt-0.5" />
                            <div>
                                <div className="font-display font-bold text-sm">Tavoli illimitati</div>
                                <div className="text-xs text-elegant">Utenti illimitati</div>
                            </div>
                        </div>
                        <div className="bg-deep border border-[#1f2c44] rounded-lg p-4 flex items-start gap-3">
                            <Sparkles className="w-5 h-5 text-brand mt-0.5" />
                            <div>
                                <div className="font-display font-bold text-sm">10 Insights AI gratis</div>
                                <div className="text-xs text-elegant">ogni mese</div>
                            </div>
                        </div>
                    </div>
                )}

                {isAdmin ? (
                    <button
                        onClick={() => navigate("/billing")}
                        data-testid="gate-billing-button"
                        className="h-14 px-8 bg-brand hover:bg-brand-light text-deep font-display font-bold uppercase tracking-wider rounded-md inline-flex items-center gap-2"
                    >
                        <Crown className="w-4 h-4" /> Vai all'abbonamento
                    </button>
                ) : (
                    <div className="text-sm text-elegant flex items-center justify-center gap-2">
                        <Clock className="w-4 h-4" /> Attendi che l'admin riattivi l'abbonamento
                    </div>
                )}
            </div>
        </div>
    );
};

export default SubscriptionGate;
